"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveSettingsToLocalStorage = exports.readSettingsFromLocalStorage = void 0;
const readSettingsFromLocalStorage = (key) => {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : {};
};
exports.readSettingsFromLocalStorage = readSettingsFromLocalStorage;
const saveSettingsToLocalStorage = (key, data) => {
    const json = JSON.stringify(data);
    localStorage.setItem(key, json);
};
exports.saveSettingsToLocalStorage = saveSettingsToLocalStorage;
//# sourceMappingURL=utils.js.map